document.addEventListener('click',function(e){
  var m=e.target.closest('.menu-t');if(m){var n=document.getElementById('nav');var o=n.classList.toggle('open');m.setAttribute('aria-expanded',o)}
  var t=e.target.closest('[data-thumb]');if(t){var g=t.closest('[data-gallery]');g.querySelector('.gal-main img').src=t.dataset.src;g.querySelectorAll('[data-thumb]').forEach(function(b){b.setAttribute('aria-current',b===t)})}
});
document.querySelectorAll('[data-pdp]').forEach(function(f){
  var s=f.querySelector('[data-variants]');if(!s)return;
  var V=JSON.parse(s.textContent),id=f.querySelector('[name=id]'),pr=f.closest('.pdp').querySelector('[data-price]'),b=f.querySelector('[data-add]');
  f.addEventListener('change',function(){
    var sel=[].map.call(f.querySelectorAll('.opt'),function(o){var c=o.querySelector('input:checked');return c?c.value:null});
    var v=V.find(function(x){return x.options.every(function(o,i){return o===sel[i]})});
    if(!v){b.disabled=true;b.textContent='Unavailable';return}
    id.value=v.id;pr.innerHTML=v.price;b.disabled=!v.available;b.textContent=v.available?b.dataset.add:'Sold out';
    if(v.img){var m=document.querySelector('.gal-main img');if(m)m.src=v.img}
  });
});
/* quick add to cart */
(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var toast=null,tt=null;
  function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML}
  function show(html){
    if(!toast){toast=document.createElement('div');toast.className='sui-toast';toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');document.body.appendChild(toast)}
    toast.innerHTML=html;toast.classList.remove('err');
    requestAnimationFrame(function(){toast.classList.add('on')});
    clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('on')},3500);
  }
  function warn(html,img){if(window.suiAlert)suiAlert(html,img);else show('<div>'+html+'</div>')}
  function setCount(n){
    document.querySelectorAll('.cart-n').forEach(function(el){el.textContent=n});
    document.querySelectorAll('.ic-cart').forEach(function(a){a.setAttribute('aria-label','Cart, '+n+(n===1?' item':' items'))});
  }
  function getCart(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})}
  document.addEventListener('click',function(e){
    var b=e.target.closest('.c2-qa');if(!b)return;
    e.preventDefault();
    var lbl=b.querySelector('.c2-qa-l'),orig=lbl?lbl.textContent:'';
    var img=b.dataset.img||'';
    var sp=null;try{sp=JSON.parse(b.dataset.spec||'null')}catch(x){}
    b.classList.add('is-busy');if(lbl)lbl.textContent='Adding…';
    function reset(){b.classList.remove('is-busy');if(lbl)lbl.textContent=orig}
    (sp&&window.suiAvail?getCart():Promise.resolve(null)).then(function(cart){
      if(cart){var q=suiCartMap(cart);if(suiAvail(sp,q)<1){reset();warn(suiMsg(sp,q,root),img);return}}
      return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(b.dataset.variant),quantity:1}]})})
        .then(function(r){return r.json().then(function(j){if(!r.ok){j._status=r.status;throw j}return j})})
        .then(getCart)
        .then(function(c){
          setCount(c.item_count);
          b.classList.remove('is-busy');b.classList.add('is-done');if(lbl)lbl.textContent='Added ✓';
          setTimeout(function(){b.classList.remove('is-done');if(lbl)lbl.textContent=orig},1800);
          show((img?'<img src="'+img+'" alt="">':'')+'<div><b>Added to cart</b>'+esc(b.dataset.title)+' · <a href="'+root+'cart">View cart</a></div>');
        });
    }).catch(function(err){
      reset();
      if(err&&err._status===422){warn('<b>Only 1 available</b> This piece is already in your cart, so it can\'t be added again.',img)}
      else{warn('<b>Couldn\'t add to cart</b> '+esc((err&&(err.description||err.message))||'Please try again.'),img)}
    });
  });
})();
